import { Row, Space, Button } from "antd";
// import { Button } from "components/elements";
import CompanyTreeEdit from "./CompanyTreeEdit";

import styles from "../styles/CompanyProfile.module.css";
import { useTranslation } from "react-i18next";

const CompanyPositionEdit = ({
  positionList = [],
  onCancel = () => { },
  onEdit = () => { },
  onSave = () => { },
  getModal = () => { },
  getEditModal = () => { },
  handleOpenCreateModal = () => { },
  handleOpenEditModal = () => { },
  deletePosition = () => { },
  lang = "",
}) => {
  const { t } = useTranslation();

  return (
    <>
      {getModal()}
      {getEditModal()}
      <Space
        className={styles.container}
        direction="vertical"
        size={24}
        style={{ overflow: "auto" }}
      >
        <Row justify="end" className={styles.container}>
          <Space size={20}>
            <Button type="default" onClick={onCancel} style={{ width: "max-content", height: "44px", borderRadius: "8px", backgroundColor: "#2CADE7", padding: "8px 16px", color: "white" }}>
              {t("common.submit")}
            </Button>
            {/* <Button className={styles.buttom} onClick={onSave}>
              {t("common.submit")}
            </Button> */}
          </Space>
        </Row>
        <div className="card" style={{ overflow: "auto", boxShadow: "none" }}>
          <CompanyTreeEdit
            positionList={positionList}
            handleOpenCreateModal={handleOpenCreateModal}
            handleOpenEditModal={handleOpenEditModal}
            lang={lang}
            deletePosition={deletePosition}
          />
        </div>
      </Space>
    </>
  );
};

export default CompanyPositionEdit;
